import React from 'react';

// eslint-disable-next-line import/no-cycle
import { ThermalResistanceCalculator } from '../../Insulation/ThermalResistanceCalculator';

// eslint-disable-next-line react/prop-types
const CMSThermalResistanceCalculator = ({ header }) => <ThermalResistanceCalculator header={header} />;

export default CMSThermalResistanceCalculator;
